import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
  Divider,
  Tab,
  Checkbox,
  Avatar,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import logo from './images/logo.png'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import Link from '@mui/material/Link'
import CreateDocumentsForm from './CreateDocumentsForm'
import AttachmentIcon from '@mui/icons-material/Attachment'
import WTypography from 'Components/whiteTypography'

import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'

import SelectCategory from './SelectCategory'
import ImportOperationsWizard from 'containers/mesComptes/ImportOperationsWizard'
import CreateOperationForm from '../containers/GestionOperations/CreateOperationForm'
import CustomButton from './CustomButton/CustomButton'
import { makePostRequest } from 'utils/api'
import EditOperationForm from '../containers/GestionOperations/EditOperationForm'

import { Bar, Line } from 'react-chartjs-2'
import Modals from './Modals'
import AddRulesModal from 'containers/categorisation/Rules/AddRulesModal'
import { DataGrid } from '@mui/x-data-grid'
import { makeGetRequest } from 'utils/api'
import { makeDeleteRequest } from 'utils/api'
import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'
import ComboBox from './ComboBox'
import { useSelector } from 'react-redux'
import { convertToUserDateFormate } from 'utils/helpers'
import moment from 'moment'
import success from 'Components/images/success.svg'
import failed from 'Components/images/failure.svg'
import OperationFiDetail from './OperationFiDetail'

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: '10px 0',
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))
const useStyles = styled((theme) => ({
  contactBox: {
    display: 'flex',
    padding: '10px 0px',
    alignItems: 'center',
    marginLeft: '40px',
  },
}))
const CurrentAccount = () => {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // Detect mobile screen size

  const siteUser = useSelector((store) => store.user)

  const classes = useStyles()
  let navigate = useNavigate()
  const [openAContactForm, setOpenAContactForm] = useState(false)

  const [checked, setChecked] = useState(false)
  const [handelCategories, sethandelCategories] = useState(false)
  const [accountData, setAccountData] = useState()
  const [value, setValue] = React.useState('1')

  const [selected, setSelected] = React.useState([])

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const optionsbar1 = {
    indexAxis: 'x',
    aspectRatio: 1,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: 'white', // Couleur du texte pour les axes X
        },
      },
      y: {
        ticks: {
          color: 'white', // Couleur du texte pour les axes Y
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: 'white',
        // formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
      },

      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  let params = useParams()
  React.useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = async () => {
    const { data } = await makeGetRequest('/api/Finance/Accounts/' + params.id + '/', {}, true)
    setChecked(data.ExcludeFromBudget)
    setAccountData(data)
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteVehicleContacts,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchAccounts()
        setSelected([])
      }
    }
  }
  const contact = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <Box sx={{ display: 'flex', pb: 3 }}>
        <WTypography variant="h6">Contact</WTypography>
        <Box sx={{ marginLeft: 'auto' }}>
          <CustomButton onClick={() => setOpenAContactForm(true)}>Ajouter</CustomButton>
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>

      <Box>
        {accountData?.contactsList?.map((row, index) => (
          <Box
            key={row.id}
            sx={{ display: 'flex', '.MuiCheckbox-root': { color: 'white !important' } }}
          >
            <Checkbox
              onClick={(event) => handleClick(event, row.id)}
              color="secondary"
              inputProps={{
                'aria-labelledby': index,
              }}
            />
            <Box
              className={classes.contactBox}
              onClick={() => navigate(`/MesContacts?cid=${row.contact}`)}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Avatar sx={{ marginRight: '10px' }} alt="" src={row.contactObj?.Picture} />
              <WTypography>
                {row.contactObj?.Titres?.Titre}. {row.contactObj?.Nom} --------- {row.role}
              </WTypography>
            </Box>
          </Box>
        ))}
        {accountData?.contactsList?.length === 0 && <Box sx={{ color: 'white' }}>No contact</Box>}
      </Box>
    </Box>
  )
  const Synthese = ({ accountData }) => {
    const [togel, setTogel] = React.useState(true)
    const [revsum, setrevsum] = React.useState(0)
    const [depsum, setdepsum] = React.useState(0)
    const [oac, setOac] = React.useState(0)
    const [revdata, setRevData] = useState({
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
        },
      ],
    })
    const [depData, setDepData] = useState({
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
        },
      ],
    })
    const [cflowData, setcflowData] = useState({
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
        },
      ],
    })
    const [soldedata, setSoldeData] = React.useState({
      labels: [],
      datasets: [
        {
          label: 'Solde',
          data: [],
          backgroundColor: ['#60829b'],
          borderColor: ['#60829b'],
          barThickness: 20,
        },
      ],
    })
    const [catedata, setCateData] = React.useState({
      labels: ['date', 'date1', 'date2'],
      datasets: [
        {
          label: 'cat',
          data: [2, 5, 6],
          backgroundColor: ['#60829b'],
          borderColor: ['#60829b'],
          barThickness: 20,
        },
        {
          label: 'cat1',
          data: [6, 3, 9],
          backgroundColor: ['#60829b'],
          borderColor: ['#60829b'],
          barThickness: 20,
        },
      ],
    })
    const optionsline = {
      indexAxis: 'x',
      responsive: true,
      aspectRatio: 1,
      maintainAspectRatio: false,

      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: { color: 'white' },
        },
        y: {
          ticks: { color: 'white' },
        },
      },
    }
    const optionsline2 = {
      indexAxis: 'x',
      responsive: true,
      aspectRatio: 2.4,

      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          position: 'right',
        },
      },
      scales: {
        x: {
          ticks: { color: 'white' },
        },
        y: {
          ticks: { color: 'white' },
        },
      },
    }

    React.useEffect(() => {
      fetchSynthese()
      const filterresult = accountData.operation.filter((v) => v.SousCategorie.length === 0)
      setOac(filterresult.length)
    }, [])
    const fetchSynthese = async () => {
      const { data } = await makeGetRequest(
        '/api/Finance/AccountsSynthese/' + accountData.id + '/',
        {},
        true,
      )

      let solde = data.filter((v) => v.type === 'solde')
      let solde_label = []
      let solde_data = []
      solde[0].data.forEach((v) => {
        solde_data.push(v.solde)
        solde_label.push(convertToUserDateFormate(siteUser.user, v.date))
      })

      setSoldeData({
        labels: solde_label,
        datasets: [
          {
            label: 'Solde',
            data: solde_data,
            backgroundColor: ['#60829b'],
            borderColor: ['#60829b'],
            barThickness: 20,
          },
        ],
      })
      let revenue = data.filter((v) => v.type === 'revenu')

      let revenue_label = []
      let revenue_data = []
      revenue[0].data[0].forEach((v) => {
        revenue_label.push(v.SousCategorie__SousCategorie ? v.SousCategorie__SousCategorie : 'N/A')
        revenue_data.push(v.Montant)
      })

      setRevData({
        labels: revenue_label,
        datasets: [
          {
            data: revenue_data,
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
          },
        ],
      })
      let depense = data.filter((v) => v.type === 'depense')
      let depense_label = []
      let depense_data = []
      depense[0].data[0].forEach((v) => {
        depense_label.push(v.SousCategorie__SousCategorie ? v.SousCategorie__SousCategorie : 'N/A')
        depense_data.push(v.Montant * -1)
      })
      setDepData({
        labels: depense_label,
        datasets: [
          {
            data: depense_data,
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
          },
        ],
      })
      let rev_sum = 0
      let dep_sum = 0
      revenue_data.forEach((v) => {
        rev_sum += v
      })
      depense_data.forEach((v) => {
        dep_sum += v
      })
      setrevsum(rev_sum)
      setdepsum(dep_sum)
      setcflowData({
        labels: ['Revenus', 'Dépenses'],
        datasets: [
          {
            data: [rev_sum, dep_sum],
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
          },
        ],
      })
      let categories = data.filter((v) => v.type === 'categories')

      let main_labels = []
      let main_cate = []
      categories[0].data[0].forEach((v) => {
        if (main_labels.includes(v.month)) {
        } else {
          main_labels.push(v.month)
        }
        if (main_cate.includes(v.SousCategorie__SousCategorie)) {
        } else {
          main_cate.push(v.SousCategorie__SousCategorie)
        }
      })

      let datasets = []
      main_cate.forEach((v) => {
        datasets.push({
          label: v,
          data: [],
          backgroundColor: [
            '#60829b',
            '#0d6efd',
            '#6610f2',
            '#6f42c1',
            '#d63384',
            '#fd7e14',
            '#198754',
            '#dee2e6',
            '#055160',
            '#0dcaf0',
            '#58151c',
            '#495057',
            '#055160',
          ],
          borderColor: [
            '#60829b',
            '#0d6efd',
            '#6610f2',
            '#6f42c1',
            '#d63384',
            '#fd7e14',
            '#198754',
            '#dee2e6',
            '#055160',
            '#0dcaf0',
            '#58151c',
            '#495057',
            '#055160',
          ],
          barThickness: 20,
        })
      })

      main_labels.forEach((v, index) => {
        let filer_data_by_date = categories[0].data[0].filter((e) => v === e.month)

        let allcat = []

        main_cate.forEach((cm) => {
          let fff = filer_data_by_date.filter((c) => cm === c.SousCategorie__SousCategorie)

          if (fff.length > 0) {
            allcat.push(fff[0])
          } else {
            allcat.push({
              SousCategorie__SousCategorie: cm,
              month: v,
              Montant: 0,
            })
          }
        })

        allcat.forEach((vs) => {
          let temp = []
          let fildata = datasets.filter((es) => vs.SousCategorie__SousCategorie === es.label)

          let newd = fildata[0].data

          datasets.forEach((d) => {
            if (d.label === vs.SousCategorie__SousCategorie) {
              newd.push(vs.Montant)
              temp.push({ ...d, data: newd })
            } else {
              temp.push(d)
            }
          })

          datasets = temp
        })
      })

      setCateData({
        labels: main_labels,
        datasets: datasets,
      })
    }
    return (
      <Box borderRadius={1} p={1} mt={2}>
        <Box
          bgcolor={'#001B42'}
          color={'white'}
          width={isMobile ? '100%' : 200}
          display={'flex'}
          justifyContent={'center'}
          flexDirection={'column'}
          alignItems={'center'}
          py={2}
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            setValue('1')
            sethandelCategories(true)
          }}
        >
          <Box>{oac}</Box>
          <Box>Opérations à catégoriser</Box>
        </Box>
        <Box>
          <Box color={'white'} display={'flex'} justifyContent={'flex-end'}>
            <Button sx={{ color: togel ? '' : 'white' }} onClick={() => setTogel(true)}>
              Solde
            </Button>
            <Button sx={{ color: togel ? 'white' : '' }} onClick={() => setTogel(false)}>
              Catégorie
            </Button>
          </Box>
          {togel ? (
            <Box bgcolor={'#001B42'} p={1} height={350} position={'relative'} width={'100%'}>
              <Line data={soldedata} options={optionsline} />
            </Box>
          ) : (
            <Box bgcolor={'#001B42'} p={1} height={350} position={'relative'} width={'100%'}>
              <Line data={catedata} options={optionsline2} />
            </Box>
          )}
        </Box>
        <Box
          mt={2}
          display={'flex'}
          flexDirection={isMobile ? 'column' : 'row'}
          gap={3}
          justifyContent={'space-between'}
        >
          <Box bgcolor={'#001B42'} width={'100%'} p={1}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <WTypography fontSize={'22px'}>Mes revenus</WTypography>
              <WTypography fontSize={'22px'}>{revsum.toFixed(2)}</WTypography>
            </Box>
            <Box>
              <WTypography sx={{ color: '#b9b9b9' }}>
                Repartition des actifs par categorie
              </WTypography>
            </Box>
            <Box height={350} position={'relative'} width={'100%'}>
              <Bar data={revdata} options={optionsbar1} />
            </Box>
          </Box>
          <Box bgcolor={'#001B42'} width={'100%'} p={1}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <WTypography fontSize={'22px'}>Mes Dépenses</WTypography>
              <WTypography fontSize={'22px'}>{depsum.toFixed(2)}</WTypography>
            </Box>
            <Box>
              <WTypography sx={{ color: '#b9b9b9' }}>
                Repartition des dépenses par categorie
              </WTypography>
            </Box>
            <Box height={350} position={'relative'} width={'100%'}>
              <Bar data={depData} options={optionsbar1} />
            </Box>
          </Box>
          <Box bgcolor={'#001B42'} width={'100%'} p={1}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <WTypography fontSize={'22px'}>Mes Cashflow</WTypography>
              <WTypography fontSize={'22px'}>{(revsum - depsum).toFixed(2)}</WTypography>
            </Box>
            <Box>
              <WTypography sx={{ color: '#b9b9b9' }}>
                Repartition des actifs par categorie
              </WTypography>
            </Box>
            <Box height={350} position={'relative'} width={'100%'}>
              <Bar data={cflowData} options={optionsbar1} />
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
  const syncNow = async () => {}
  const Operations = (
    <BasicTable
      rows={accountData}
      syncNow={syncNow}
      fetchAccounts={fetchAccounts}
      handelCategories={handelCategories}
      sethandelCategories={sethandelCategories}
    />
  )
  const documents = <BasicTable1 />
  const updateAccountExclude = (val) => {
    const payload = {
      id: val,
    }
    makePostRequest('/api/Finance/POST/UpdateAccountExclude/', payload, {}, true)
  }
  const [infoshow, setInfoShow] = useState(true)
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  return (
    <>
      {openAContactForm && (
        <AddContact setOpen={setOpenAContactForm} updateAccount={fetchAccounts} vid={params.id} />
      )}

      <Container>
        {accountData && (
          <>
            <Grid container sx={{ marginTop: '5px' }} spacing={2}>
              <Grid item xs={12} md={5}>
                <Item style={{ backgroundColor: 'transparent' }}>
                  <Box
                    sx={{
                      img: {
                        height: '200px',
                      },
                    }}
                  >
                    <img
                      src={accountData && accountData.Nom ? accountData.Nom.logo : logo}
                      width="300"
                      height="200"
                      style={{
                        objectFit: 'contain',
                        // borderRadius: "50%",
                      }}
                      alt="Logo"
                    />
                  </Box>
                  <Box padding="15px">
                    <Divider />
                  </Box>
                </Item>
              </Grid>
              <Grid item xs={12} md={7}>
                <Item style={{ backgroundColor: 'transparent' }}>
                  <Box>
                    <Typography variant="h6" color="white" padding="3px 0 3px 20px" align="left">
                      Information du compte
                    </Typography>
                  </Box>
                  {infoshow && (
                    <Grid container>
                      <Grid
                        textAlign={'left'}
                        item
                        xs={12}
                        md={6}
                        display={'flex'}
                        overflow={'hidden'}
                      >
                        <Grid item xs={6}>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Date Ouverture:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Date Creation:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            N° Client:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            IBAN:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Exlcure du budget:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Sync status:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.DateOuverture
                              ? convertToUserDateFormate(siteUser.user, accountData.DateOuverture)
                              : '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.DateCreation
                              ? convertToUserDateFormate(siteUser.user, accountData.DateCreation)
                              : '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.NumeroClient ? accountData.NumeroClient : '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.IBAN ? accountData.IBAN : '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                            sx={{
                              ':hover': { cursor: 'pointer' },
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => {
                                setChecked(!checked)
                                updateAccountExclude(accountData.id)
                              }}
                            />
                          </Typography>
                          {accountData.sync_status === 'Success' && (
                            <img style={{ height: '36px' }} src={success} alt="" />
                          )}
                          {accountData.sync_status === 'Failed' && (
                            <img style={{ height: '36px' }} src={failed} alt="" />
                          )}
                        </Grid>
                      </Grid>
                      <Grid
                        xs={12}
                        md={6}
                        item
                        textAlign={'left'}
                        display={'flex'}
                        // width="22%"
                      >
                        <Grid item xs={6} textAlign="left" float="right">
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Titulaire:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            N° Compte:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Ville:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Rue:
                          </Typography>
                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Solde:
                          </Typography>

                          <Typography
                            className="text-left"
                            variant="subtitle2"
                            color="rgb(255 255 255 / 60%)"
                          >
                            Last sync date:
                          </Typography>
                        </Grid>
                        <Grid item xs={6} textAlign="left" float="right">
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.Titulaire | '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.NumeroCompte | '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.Nom?.Ville | '-'}
                          </Typography>
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.Nom?.NomRue | '-'}
                          </Typography>
                          {parseFloat(accountData.balance) > 0 ? (
                            <Typography
                              lineHeight="1.57"
                              className="text-left"
                              variant="body2"
                              color="green"
                            >
                              {accountData.balance}-
                              <Box component={'span'} sx={{ color: 'white' }}>
                                {accountData.Devise}
                              </Box>
                            </Typography>
                          ) : (
                            <Typography
                              lineHeight="1.57"
                              className="text-left"
                              variant="body2"
                              color="red"
                            >
                              {accountData.balance}
                            </Typography>
                          )}
                          <Typography
                            lineHeight="1.57"
                            className="text-left"
                            variant="body2"
                            color="white"
                          >
                            {accountData.account_id
                              ? moment(accountData.last_sync_date, 'YYYY-MM-DDThh:mm:ss').fromNow()
                              : '-'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Box>
                    {isMobile && (
                      <>
                        {infoshow ? (
                          <KeyboardArrowUpIcon
                            sx={{
                              color: 'white',
                              bgcolor: 'gray',
                              borderRadius: 5,
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setInfoShow(!infoshow)
                            }}
                          />
                        ) : (
                          <KeyboardArrowDownIcon
                            sx={{
                              color: 'white',
                              bgcolor: 'gray',
                              borderRadius: 5,
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setInfoShow(!infoshow)
                            }}
                          />
                        )}
                      </>
                    )}
                  </Box>
                </Item>
              </Grid>
            </Grid>

            <WTypography variant="h4" sx={{ textAlign: 'left', marginTop: '20px' }}>
              Mon Compte
            </WTypography>

            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList
                    onChange={handleChange}
                    sx={{ '& .MuiTabs-flexContainer': { display: 'block !important' } }}
                  >
                    <Tab sx={{ color: 'white' }} label="Opérations" value="1" />
                    <Tab sx={{ color: 'white' }} label="Document" value="2" />

                    <Tab sx={{ color: 'white' }} label="Contact" value="3" />

                    <Tab sx={{ color: 'white' }} label="Synthèse" value="4" />
                  </TabList>
                </Box>

                <TabPanel value="1" sx={{ p: isMobile ? 0 : 3 }}>
                  {Operations}
                </TabPanel>
                <TabPanel value="2">{documents}</TabPanel>
                <TabPanel value="3">{contact}</TabPanel>
                <TabPanel value="4">
                  <Synthese accountData={accountData} />
                </TabPanel>
              </TabContext>
            </Box>
          </>
        )}
      </Container>
    </>
  )
}

export default CurrentAccount

function AddContact({ vid, updateAccount, setOpen }) {
  const [contacts, setContacts] = useState([])

  const roles = [
    { id: 1, label: 'Titulaire' },
    { id: 2, label: 'Co-titulaire' },
    { id: 3, label: 'Mandataire' },
    { id: 4, label: 'Bénéficaire' },
    { id: 5, label: 'Conseiller' },
    { id: 6, label: 'Contact d’urgence ' },
    { id: 7, label: 'Débiteur' },
    { id: 8, label: 'Créancier' },
    { id: 9, label: 'Ayant-droit' },
    { id: 10, label: 'Héritier' },
    { id: 11, label: 'Auditeur' },
    { id: 12, label: 'Partenaire de paiement' },
    { id: 13, label: 'Assureur' },
  ]

  const { handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      contact: '',
      account: vid,
      role: '',
    },
  })

  useEffect(() => {
    fetchContacts()
  }, [])
  const fetchContacts = async () => {
    const filterContacts = []
    const { data } = await makeGetRequest('/api/Social/get-all-contacts/', {}, true)
    data.map((v) => {
      filterContacts.push({ label: v.Nom, id: v.id })
      return ''
    })
    setContacts([...filterContacts])
  }
  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      contact: data.contact.id,
      role: data.role.label,
    }

    const response = await makePostRequest(urls.addVContactOp, payload, {}, true)
    if (response.status === 201) {
      updateAccount()
      handleClose()
    }
  }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={true} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Affectation contact</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('contact', j)
              }}
              label="Sélectionner contact"
              data={contacts}
              name="contact"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('role', j)
              }}
              label="Rôles"
              data={roles}
              name="role"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

function BasicTable1() {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])

  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/Documents/${id}/?limit=${limit}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }
  return (
    <>
      <Box>
        <Typography variant="h5" pl={3} pt={3} sx={{ color: 'white' }}>
          Related documents
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={3} sx={{ color: 'white' }}>
            Documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={params} account="Comptes" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />

                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}

// LAP — Refonte du tableau opérations avec scroll infini + redesign.
// - Plus de pagination à clic : on accumule les lignes au fil du scroll
// - Headers contrastés en uppercase
// - Montants formatés (Intl.NumberFormat) + couleur (vert recettes / rouge dépenses)
// - Chip de catégorie avec couleur
// - Recharge si filtre/tri changent
// - useParams() pour l'id de compte (au lieu de dépendre du parent)
function ListOperationsOfTable({
  fetchOperations,
  operations,
  setSelectedRows,
  setOperations,
  updateLoading,
  categories,
  devise,
}) {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t, i18n } = useTranslation('common')

  const [modifiedColumns, setModifiedColumns] = useState([])
  const [sortModel, setSortModel] = useState([])
  const [detailModel, setDetailModel] = useState({})
  const [filterModel, setFilterModel] = useState({ items: [] })
  const [localRows, setLocalRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)

  const PAGE_SIZE = 50
  const params = useParams()
  let navigate = useNavigate()
  const scrollerRef = useRef(null)
  const sentinelRef = useRef(null)

  // Localisation pour Intl.NumberFormat
  const locale = React.useMemo(() => {
    switch ((i18n.language || 'fr').slice(0, 2)) {
      case 'en':
        return 'en-US'
      case 'de':
        return 'de-DE'
      case 'it':
        return 'it-IT'
      case 'es':
        return 'es-ES'
      default:
        return 'fr-FR'
    }
  }, [i18n.language])

  const formatMoney = (value, currency) => {
    const num = Number(value)
    if (!Number.isFinite(num)) return '—'
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: ((currency || devise || 'EUR') + '').toUpperCase(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num)
    } catch (e) {
      return `${num.toFixed(2)} ${currency || devise || ''}`.trim()
    }
  }

  const buildQuery = (offset) => {
    let url = `?limit=${PAGE_SIZE}&offset=${offset}`
    filterModel.items.forEach((f) => {
      if (f.value) url += `&${f.columnField}=${encodeURIComponent(f.value)}`
    })
    if (Array.isArray(sortModel)) {
      sortModel.forEach((s) => {
        const direction = s.sort === 'desc' ? '-' : ''
        url += `&ordering=${direction}${s.field}`
      })
    }
    return url
  }

  // Reset + premier chargement à chaque changement de filtre/tri/compte
  useEffect(() => {
    let cancelled = false
    const loadFirstPage = async () => {
      setLoading(true)
      setLocalRows([])
      setHasMore(true)
      const res = await makeGetRequest(
        `/api/Finance/Operationsfi/${params.id}${buildQuery(0)}`,
        {},
        true,
      )
      if (!cancelled && res.status === 200) {
        const results = res.data.results || []
        const count = res.data.count || 0
        setLocalRows(results)
        setHasMore(results.length < count)
        if (typeof setOperations === 'function') {
          setOperations({ ...res.data })
        }
      }
      if (!cancelled) setLoading(false)
    }
    loadFirstPage()
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id, JSON.stringify(filterModel), JSON.stringify(sortModel)])

  // Chargement page suivante
  const loadMore = React.useCallback(async () => {
    if (loading || !hasMore) return
    setLoading(true)
    const res = await makeGetRequest(
      `/api/Finance/Operationsfi/${params.id}${buildQuery(localRows.length)}`,
      {},
      true,
    )
    if (res.status === 200) {
      const results = res.data.results || []
      const count = res.data.count || 0
      // Dédup par id pour parer aux courses StrictMode / scroll trop rapide
      setLocalRows((prev) => {
        const known = new Set(prev.map((r) => r.id))
        const fresh = results.filter((r) => !known.has(r.id))
        const merged = [...prev, ...fresh]
        setHasMore(merged.length < count)
        return merged
      })
    }
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, hasMore, params.id, localRows.length, filterModel, sortModel])

  // IntersectionObserver pour déclencher loadMore quand la sentinelle entre en vue
  useEffect(() => {
    const node = sentinelRef.current
    if (!node) return
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) loadMore()
      },
      { root: null, rootMargin: '300px', threshold: 0 },
    )
    obs.observe(node)
    return () => obs.disconnect()
  }, [loadMore])

  const columns = [
    {
      field: 'Date',
      headerName: t('mesComptes.columns.date') || 'Date',
      width: 130,
      type: 'date',
      headerClassName: 'op-header',
      valueGetter: (p) => {
        const rawDate = p.row.Date
        if (!rawDate) return null
        const [dd, mm, yyyy] = rawDate.split('-')
        return new Date(`${yyyy}-${mm}-${dd}`)
      },
      renderCell: (p) => (
        <Box sx={{ fontVariantNumeric: 'tabular-nums', color: '#3a4661' }}>
          {convertToUserDateFormate(siteUser.user, p.row.Date)}
        </Box>
      ),
    },
    {
      field: 'Libelle',
      headerName: t('mesComptes.columns.libelle') || 'Libellé',
      flex: 1.4,
      minWidth: 220,
      headerClassName: 'op-header',
      renderCell: (p) => (
        <Box sx={{ fontWeight: 500, color: '#0d1b3d', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {p.row.Libelle}
        </Box>
      ),
    },
    {
      field: 'Categorie',
      headerName: t('mesComptes.columns.category') || 'Catégorie',
      width: 170,
      headerClassName: 'op-header',
      valueGetter: (p) =>
        p.row.SousCategorie && p.row.SousCategorie.length > 0 ? p.row.SousCategorie[0].Categorie : '',
      renderCell: (p) => {
        const v = p.value
        if (!v) return <span style={{ color: '#9aa3b8' }}>—</span>
        return (
          <Box
            component="span"
            sx={{
              bgcolor: '#eef3ff',
              color: '#0d3a7a',
              px: 1.2,
              py: 0.4,
              borderRadius: 1.5,
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            {v}
          </Box>
        )
      },
    },
    {
      field: 'SousCategorie',
      headerName: t('mesComptes.columns.subcategory') || 'Sous-catégorie',
      width: 230,
      headerClassName: 'op-header',
      renderCell: (p) => (
        <SelectCategory updateLoading={updateLoading} categories={categories} row={p.row} />
      ),
    },
    {
      field: 'Montant',
      headerName: t('mesComptes.columns.amount') || 'Montant',
      width: 140,
      type: 'number',
      align: 'right',
      headerAlign: 'right',
      headerClassName: 'op-header',
      valueGetter: (p) => (p.row.Montant != null ? Number(p.row.Montant) : 0),
      sortComparator: (a, b) => a - b,
      renderCell: (p) => {
        const num = Number(p.row.Montant)
        const color = !Number.isFinite(num) || num === 0 ? '#3a4661' : num > 0 ? '#1f7a3d' : '#c0392b'
        return (
          <Box
            sx={{
              fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
              fontWeight: 600,
              color,
            }}
          >
            {formatMoney(num, devise)}
          </Box>
        )
      },
    },
  ]

  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Date',
          headerName: t('mesComptes.columns.date') || 'Date',
          width: 190,
          flex: 1,
          headerClassName: 'op-header',
          renderCell: (p) => (
            <Box py={1.5}>
              <Box sx={{ fontWeight: 600, color: '#0d1b3d' }}>
                {convertToUserDateFormate(siteUser.user, p.row.Date)}
              </Box>
              <Box sx={{ fontSize: 13, mt: 0.5 }}>
                <Box component="span" sx={{ color: '#6b7790' }}>
                  {t('mesComptes.columns.libelle') || 'Libellé'} :
                </Box>{' '}
                <Box component="span" fontWeight={500}>
                  {p.row.Libelle}
                </Box>
              </Box>
              <Box sx={{ fontSize: 12, mt: 0.5, color: '#6b7790' }}>
                {p.row.SousCategorie && p.row.SousCategorie.length > 0
                  ? p.row.SousCategorie[0].Categorie
                  : ''}
              </Box>
              <Box sx={{ mt: 1 }}>
                <SelectCategory
                  key={p.row.id}
                  updateLoading={updateLoading}
                  categories={categories}
                  row={p.row}
                />
              </Box>
            </Box>
          ),
        },
        {
          field: 'Montant',
          headerName: t('mesComptes.columns.amount') || 'Montant',
          width: 120,
          type: 'number',
          align: 'right',
          headerAlign: 'right',
          cellClassName: 'dtcell',
          headerClassName: 'op-header',
          renderCell: (p) => {
            const num = Number(p.row.Montant)
            const color =
              !Number.isFinite(num) || num === 0 ? '#3a4661' : num > 0 ? '#1f7a3d' : '#c0392b'
            return (
              <Box pt={1.5}>
                <Box
                  sx={{
                    fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
                    fontWeight: 700,
                    color,
                  }}
                >
                  {formatMoney(num, devise)}
                </Box>
              </Box>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, categories, devise, locale])

  // Sentinelle infinite scroll, rendue dans le footer du DataGrid
  const InfiniteFooter = () => (
    <Box
      sx={{
        p: 1.5,
        textAlign: 'center',
        borderTop: '1px solid #eef0f4',
        background: '#fafbfd',
        fontSize: 12,
        color: '#6b7790',
      }}
    >
      <Box ref={sentinelRef} />
      {loading
        ? '…'
        : hasMore
        ? `${localRows.length} / ${operations.count || '—'}`
        : `— ${t('mesComptes.titleWithCount', { count: localRows.length })} —`}
    </Box>
  )

  return (
    <>
      {detailModel && detailModel?.id && (
        <OperationFiDetail handleClose={setDetailModel} row={detailModel} />
      )}
      <div
        style={{
          width: '100%',
          background: 'white',
          borderRadius: 8,
          boxShadow: '0 1px 3px rgba(13,27,61,0.08)',
          overflow: 'hidden',
        }}
        ref={scrollerRef}
      >
        <Box
          sx={{
            px: 2.5,
            pt: 2,
            pb: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #eef0f4',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d1b3d', fontSize: 16 }}>
            {t('mesComptes.titleWithCount', { count: operations.count || localRows.length })}
          </Typography>
        </Box>
        <DataGrid
          sx={{
            border: 0,
            height: 700,
            fontSize: isMobile ? '11px' : '13px',
            '.dtcell': { alignItems: 'flex-start' },
            '& .op-header': {
              backgroundColor: '#f4f6fb',
              color: '#0d1b3d',
              fontWeight: 700,
              textTransform: 'uppercase',
              fontSize: 11,
              letterSpacing: 0.5,
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '1px solid #e3e8f1',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #f1f3f8',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f7f9fc',
            },
            '& .MuiDataGrid-row.Mui-selected': {
              backgroundColor: '#e8eef9',
              '&:hover': { backgroundColor: '#dde6f5' },
            },
          }}
          rows={localRows}
          columns={modifiedColumns}
          getRowHeight={() => (isMobile ? 'auto' : 56)}
          hideFooterPagination
          onSelectionModelChange={(itm) => setSelectedRows([...itm])}
          checkboxSelection
          disableSelectionOnClick
          filterMode="server"
          onRowClick={(row, event) => {
            if (event.target.localName === 'div') {
              setDetailModel(row)
            }
          }}
          onFilterModelChange={(newModel) => {
            setFilterModel(newModel)
          }}
          sortingMode="server"
          onSortModelChange={(newModel) => setSortModel(newModel)}
          components={{
            Footer: InfiniteFooter,
          }}
        />
      </div>
    </>
  )
}
function BasicTable({
  syncNow,
  rows,
  fetchCalculations,
  handelCategories = false,
  sethandelCategories,
  fetchAccounts,
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  let params = useParams()
  const [categories, setCategories] = useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState({})
  const [selected, setSelected] = React.useState([])
  const [noCategories, setNoCategories] = React.useState(false)
  const addRulesRef = useRef(null)
  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })
  const [importWizardOpen, setImportWizardOpen] = useState(false)

  const handleImportComplete = () => {
    setImportWizardOpen(false)
    updateLoading()
    setOpenSnak({
      open: true,
      color: 'success',
      message: 'Operations imported successfully',
    })
    setTimeout(() => {
      setOpenSnak({
        open: false,
        color: '',
        message: '',
      })
    }, 3000)
  }
  useEffect(() => {
    fetchCategory()
    fetchOperations('')
  }, [])
  const handleChange = (e) => {
    fetchOperations('')
    // setUpdateTable( !updateTable );
  }
  const fetchOperations = async (url = '') => {
    const response = await makeGetRequest(`/api/Finance/Operationsfi/${params.id}${url}`, {}, true)
    if (response.status === 200) {
      setNewRows({ ...response.data })
      if (handelCategories) {
        const filterresult = response.data.results.filter((v) => v.SousCategorie.length === 0)

        setNoCategories(true)
        setNewRows((operations) => ({
          ...operations,
          results: filterresult,
        }))
        sethandelCategories(false)
      }
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    // fetchOperations(params.id, rowsPerPage + 20)
  }
  const fetchCategory = async () => {
    const { data } = await makeGetRequest('/api/Finance/Categoriesfi/', {}, true)
    setCategories([...data])
  }
  const updateLoading = async (e) => {
    // fetchOperations(params.id, 20)
    fetchAccounts()
    fetchOperations('')
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const isSelected = (name) => selected.indexOf(name) !== -1
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = newRows.results?.map((n) => n.id)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = newRows.results.filter((v) => selected.indexOf(v.id) === -1)
      setNewRows({
        ...newRows,
        results: filteredOperations,
        count: newRows.count - selected.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        setSelected([])
        fetchAccounts()
      }
    }
  }

  const filterNonCategories = () => {
    const filterresult = newRows.results.filter((v) => v.SousCategorie.length === 0)

    setNoCategories(true)
    setNewRows((operations) => ({
      ...operations,
      results: filterresult,
    }))
  }
  const VoirTout = () => {
    setNoCategories(false)
    updateLoading()
  }
  const deleteCat = async (selected) => {
    selected.forEach(async function (id) {
      await makeDeleteRequest('/api/Finance/del/category/' + id, {}, true)
      fetchCategory()
    })
    setOpenSnak({
      open: true,
      color: 'info',
      message: 'Successfully delete catégorie',
    })
    setTimeout(() => {
      setOpenSnak({
        open: false,
        color: 'success',
        message: 'catégorie add Successfully',
      })
    }, 2000)
  }
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <AddRulesModal ref={addRulesRef} handleChange={handleChange} />
      <Box textAlign={'end'}>
        {isMobile && (
          <MenuIcon
            onClick={handleClickMenu}
            sx={{ color: 'gray', mb: 3, ml: 'auto', cursor: 'pointer' }}
          />
        )}
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <Modals
            label={'Gérer catégories'}
            handleChange={handleChange}
            categories={categories}
            deleteCat={deleteCat}
          />
        </MenuItem>
        <MenuItem>
          <Box onClick={() => addRulesRef.current.handleClickOpen()}>Gérer règle d'affectation</Box>
        </MenuItem>
        {rows.account_id && (
          <MenuItem>
            <Box onClick={syncNow}>Sync Now</Box>
          </MenuItem>
        )}

        <MenuItem>
          {noCategories ? (
            <Box onClick={VoirTout}>Voir tout</Box>
          ) : (
            <Box onClick={filterNonCategories}>Non catégorisés</Box>
          )}
        </MenuItem>
        <MenuItem>
          <Box onClick={() => setImportWizardOpen(true)}>Importer donnée</Box>
        </MenuItem>
        <MenuItem>
          <CreateOperationForm
            setOperations={setNewRows}
            account={rows.id}
            update={updateLoading}
          />
        </MenuItem>

        <MenuItem>
          <EditOperationForm
            account={rows.id}
            selectedRow={selected}
            operations={newRows}
            UpdateOperations={updateLoading}
          />
        </MenuItem>
        <MenuItem>
          <Box onClick={deleteBulkOperations}>Supprimer</Box>
        </MenuItem>
      </Menu>
      <Box pb={2} display={isMobile ? 'none' : 'flex'}>
        <Box display="flex">
          <Modals
            label={'Gérer catégories'}
            handleChange={handleChange}
            categories={categories}
            deleteCat={deleteCat}
          />
          <Button
            sx={{
              marginLeft: '5px',
              color: 'white',
              '&:hover': { color: 'black', backgroundColor: 'white' },
            }}
            onClick={() => addRulesRef.current.handleClickOpen()}
          >
            Gérer règle d'affectation
          </Button>
        </Box>
        <Box marginLeft={'auto'}>
          {rows.account_id && <CustomButton onClick={syncNow}>Sync Now</CustomButton>}
          {noCategories ? (
            <CustomButton onClick={VoirTout}>Voir tout</CustomButton>
          ) : (
            <CustomButton onClick={filterNonCategories}>Non catégorisés</CustomButton>
          )}
          <CustomButton onClick={() => setImportWizardOpen(true)}>Importer donnée</CustomButton>
          <CreateOperationForm
            setOperations={setNewRows}
            account={rows.id}
            update={updateLoading}
          />
          <EditOperationForm
            account={rows.id}
            selectedRow={selected}
            operations={newRows}
            UpdateOperations={updateLoading}
          />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <ListOperationsOfTable
        fetchOperations={fetchOperations}
        operations={newRows}
        setSelectedRows={setSelected}
        setOperations={setNewRows}
        updateLoading={updateLoading}
        categories={categories}
        devise={rows.Devise}
      />
      <ImportOperationsWizard
        open={importWizardOpen}
        onClose={() => setImportWizardOpen(false)}
        accounts={[]} // Not needed as we pass initialAccount
        onImportComplete={handleImportComplete}
        initialStep={1} // Start at Upload CSV File
        initialAccount={rows}
      />
    </>
  )
}
